import * as React from "react";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import {Dispatch} from "redux";
import Job from "../../../model/job/Job";
import {editJob} from "../../../store/action/job/job";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {JobInvoicePath, JobInvoicePathLabelEnum} from "../../../model/job/JobInvoicePath";
import ConfirmChangeInvoicePathModal from "./ConfirmChangeInvoicePathModal";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface DispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job) => void;
}

interface State {
	selectedInvoicePath: Option<JobInvoicePath>
}

type Props = ComponentProps & DispatchProps

class JobInvoicePathDropdown extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			selectedInvoicePath: none
		}
	}

	render() {
		const selectedInvoicePath = this.props.job.flatMap(j => j.data.invoicePath).orNull;
		return (
			<>
				<InfoModule icon={Icon.Invoice} title={"INVOICE PATH"}>
					<DropDown items={Object.keys(JobInvoicePath)}
							  itemToId={(item: JobInvoicePath) => item}
							  itemToLabel={(item: JobInvoicePath) => JobInvoicePathLabelEnum[item]}
							  selectedItemId={selectedInvoicePath}
							  placeholder={"Select invoice path"}
							  onSelect={this.onSelect}/>
				</InfoModule>
				{this.state.selectedInvoicePath.map(invoicePath =>
					<ConfirmChangeInvoicePathModal invoicePath={invoicePath}
												   onConfirm={() => this.onConfirm(invoicePath)}
												   onClose={() => this.setState({selectedInvoicePath: none})}/>).orNull}
			</>
		);
	}

	onSelect = (invoicePath: JobInvoicePath) => {
		if (this.props.job.flatMap(j => j.data.invoicePath).orNull !== invoicePath) {
			this.setState({selectedInvoicePath: option(invoicePath)})
		}
	}

	onConfirm = (invoicePath: JobInvoicePath) => {
		this.setState({selectedInvoicePath: none}, () =>
			this.props.job.map(j => {
				const updatedJob = j.copy({data: j.data.copy({invoicePath: option(invoicePath)})});
				this.props.editJob(updatedJob);
			}))
	};
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Invoice path updated", "Job details update"),
				(err) => notifyBugsnagAndShowToast(err, "Job details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(JobInvoicePathDropdown)